import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BRAND = 'Felton Audiences';

const ROUTE_TITLES: Record<string, string> = {
  // V11 routes
  '/v11/discovery': 'Discovery',
  '/v11/channels': 'Channels',
  '/v11/funnel': 'Funnel',
  '/v11/funnel/explore': 'Content Universe',
  '/v11/audience': 'Audience',
  '/v11/compare': 'Compare',
  '/v11/overlap': 'Overlap',

  // Shared routes
  '/login': 'Login',
  '/forgot-password': 'Forgot Password',
  '/reset-password': 'Reset Password',

  // Settings
  '/v11/settings': 'Settings',
  '/v11/profile': 'Profile',
};

function getPageTitle(pathname: string): string {
  // Exact match first
  const exact = ROUTE_TITLES[pathname];
  if (exact) {
    return `${exact} - ${BRAND}`;
  }

  // Try progressively shorter paths (for nested routes)
  const segments = pathname.split('/').filter(Boolean);
  for (let i = segments.length - 1; i > 0; i--) {
    const partial = '/' + segments.slice(0, i).join('/');
    const match = ROUTE_TITLES[partial];
    if (match) {
      return `${match} - ${BRAND}`;
    }
  }

  return BRAND;
}

export function usePageTitle(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = getPageTitle(pathname);
  }, [pathname]);
}
